import { render, staticRenderFns } from "./MarketerAffiliateCommissions.vue?vue&type=template&id=590f840c"
import script from "./MarketerAffiliateCommissions.vue?vue&type=script&lang=js"
export * from "./MarketerAffiliateCommissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports